import dynamic from "next/dynamic";
import AnimatingBoardHomepageFirstFoldConfig from "./animating-board-homepage-first-fold-config";
import AnimatingBoardHomepageFirstFoldAdvancedConfig from "./animating-board-homepage-first-fold-advanced-config";
const AnimatingBoardHomepageFirstFoldComponent = dynamic(()=>import("./animating-board-homepage-first-fold-component"));
export default {
    AnimatingBoardHomepageFirstFoldComponent,
    AnimatingBoardHomepageFirstFoldConfig,
    AnimatingBoardHomepageFirstFoldAdvancedConfig
};
